import * as React from "react";
import {
  As,
  HStack,
  Icon,
  Link as ChakraLink,
  LinkProps,
  Text
} from "@chakra-ui/react";
import { NavLink as Link, useLocation } from "react-router-dom";

interface NavLinkProps extends LinkProps {
  label: string;
  icon: As;
  to: string;
  size: "sm" | "lg";
}

const NavLink: React.FC<NavLinkProps> = ({
  icon,
  label,
  to,
  size,
  ...rest
}) => {
  const { pathname } = useLocation();

  return (
    <ChakraLink
      as={Link}
      to={to}
      display="block"
      py={size === "lg" ? "3.5" : "4"}
      px={4}
      aria-current={pathname.indexOf(`/${to}`) >= 0 ? "page" : undefined}
      color="gray.200"
      borderRadius="md"
      _hover={{
        bg: "gray.100",
        color: "gray.800"
      }}
      _activeLink={{
        bg: "gray.100",
        color: "gray.800"
      }}
      {...rest}
    >
      <HStack spacing={3} justify={size === "lg" ? "start" : "center"}>
        <Icon as={icon} boxSize={5} />
        {size === "lg" && (
          <Text
            as="span"
            lineHeight="4"
            letterSpacing="0.05em"
            fontSize="xs"
            textTransform="uppercase"
          >
            {label}
          </Text>
        )}
      </HStack>
    </ChakraLink>
  );
};

export default NavLink;
